import { Box, Text, Image, position } from "@chakra-ui/react";
import WarnIcon from "./assets/warn.png";
import { CloseIcon } from "@/components/icons";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUserInfo } from "@/context/UserInfo";

const UnverifiedTip = () => {
  const [showTip, setShowTip] = useState(
    localStorage.getItem("verifyTip") ? false : true
  );
  const navigate = useNavigate();
  const { bridgeCustomer } = useUserInfo();

  const s = showTip && bridgeCustomer?.kyc_status !== "approved";

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: "0",
        left: "0",
        width: "100%",
        height: "48px",
        background: "#F13434",
        padding: "10px 16px 0",
        fontSize: "12px",
        color: "#fff",
        display: s ? "block" : "none",
      }}
    >
      <Box
        sx={{
          fontSize: "12px",
          textAlign: "center",
        }}
      >
        <Image
          src={WarnIcon}
          sx={{ width: "16px", display: "inline-block", marginRight: "4px" }}
        ></Image>
        <span
          onClick={() => {
            if (bridgeCustomer.id) {
              navigate("/verifyInfo");
            } else {
              navigate("/createKyc");
            }
          }}
          style={{
            textDecoration: "underline",
            display: "inline-block",
            marginRight: "4px",
          }}
        >
          Unverified
        </span>
        <span style={{ display: "inline-block", wordBreak: "break-all" }}>
          account cannot withdraw to bank account
        </span>
      </Box>

      <Text
        sx={{
          textAlign: "center",
        }}
      >
        {" "}
        and can only withdraw to wallet.
      </Text>
      <CloseIcon
        onClick={() => {
          setShowTip(false);
          localStorage.setItem("verifyTip", "false");
        }}
        style={{
          position: "absolute",
          right: "8px",
          top: "50%",
          transform: "translateY(-50%)",
        }}
      ></CloseIcon>
    </Box>
  );
};

export default UnverifiedTip;
